import { CloseCircleGreyIcon } from 'assets';
import { ModalPortal, MODAL_LAYER } from 'components/modal-portal';

interface InsufficientCreditsModalProps {
  isOpen: boolean;
  onClose: () => void;
  credits: number;
  maxCredits: number;
  cost: number;
  actionLabel: string;
  onTopUp: () => void;
}

export const InsufficientCreditsModal = ({
  isOpen,
  onClose,
  credits,
  maxCredits,
  cost,
  actionLabel,
  onTopUp,
}: InsufficientCreditsModalProps) => {
  if (!isOpen) return null;

  return (
    <ModalPortal>
    <div
      className="fixed inset-0 flex items-center justify-center"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', zIndex: MODAL_LAYER.gate }}
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-2xl p-8 max-w-[440px] w-[90%] text-center"
        style={{ boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 hover:opacity-80 transition-opacity"
        >
          <CloseCircleGreyIcon className="w-7 h-7" />
        </button>
        <h3 className="text-xl font-bold text-[#101828] mb-2 mt-2">
          Insufficient Credits
        </h3>
        <p className="text-4xl font-bold text-[#101828] mb-4">{credits}</p>
        <p className="text-sm text-[#475467] mb-1">Available Credits</p>
        <div className="w-full bg-[#F2F4F7] rounded-full h-2 mb-6">
          <div
            className="bg-[#012169] h-2 rounded-full"
            style={{ width: `${maxCredits > 0 ? (credits / maxCredits) * 100 : 0}%` }}
          />
        </div>
        <p className="text-sm text-[#475467] leading-relaxed mb-6">
          {actionLabel} will cost you <b>{cost}</b> credits.
          You currently have <b>{credits}</b> credits remaining.
          Top up your credits to continue.
        </p>
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 border border-[#D0D5DD] text-[#344054] font-medium rounded-lg hover:bg-[#F9FAFB] transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onTopUp}
            className="flex-1 py-3 bg-[#012169] text-white font-medium rounded-lg hover:bg-[#011557] transition-colors"
          >
            Top Up Credits
          </button>
        </div>
      </div>
    </div>
    </ModalPortal>
  );
};
